document.addEventListener('DOMContentLoaded', function (){

    //input / select / textarea & label styling
    let inputs = document.querySelectorAll('.ltp_inputLab input, .ltp_selectLab select, .ltp_textareaLab textarea');

    if(inputs.length > 0) {
        inputs.forEach((el)=>{
            if(el.value.length > 0) {
                el.nextElementSibling.classList.add('active');
                el.classList.add('active');
            }
            el.addEventListener('change', function (){
                if(el.value.length > 0) {
                    el.nextElementSibling.classList.add('active');
                    el.classList.add('active');
                } else {
                    el.nextElementSibling.classList.remove('active');
                    el.classList.remove('active');
                }
            })
        })
    }
})
